module.exports = __webpack_public_path__ + "static/img/before_eight.86ebb8ad.png";